import { render, staticRenderFns } from "./OrganizationSwitcher.vue?vue&type=template&id=4bbfb1a1&"
import script from "./OrganizationSwitcher.vue?vue&type=script&lang=js&"
export * from "./OrganizationSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports